import { useEffect } from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Wrapper } from "../../common-styles";
import HausflixNotice from "../HausflixNotice";
import checkedImage from "../../images/check.png";
import { appendScriptHtml } from "../../services/helper";
import { clearOtpSession } from "../../store/slices/otpSlice";

const CheckedLogo = styled.img`
  width: 128px;
  height: 128px;
`;
const Body = styled.p`
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  margin-bottom: 6px;
`;
const Greeting = styled.p`
  font-size: 15px;
  color: #1a1a1a;
  margin-top: 20px;
  margin-bottom: 0;
`;
const ThanksButton = styled(Button)`
  border: none;
  font-size: 18px;
  font-weight: 600;
  border-radius: 4px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  &:hover {
    background-color: ${({ $backgroundColor }) => $backgroundColor} !important;
  }
`;

/**
 * ThanksDigital — shown after successful digital verification + availability selection.
 * Renders inside <QuestionContainer> — parent already has Background, Header, Footer.
 * Text modified per ticket spec (different from standard Greet component).
 */
const ThanksDigitalPage = () => {
  const { funnel } = useSelector((state) => state.funnelInfo);
  const reclaimMode = useSelector((state) => state.reclaimMode);
  const digitalThankyouConfig = useSelector(
    (state) => state.otp.digitalThankyouConfig
  );
  const baseColor = funnel.design?.baseColor;
  const websiteUrl = funnel.companyInfo?.companyWebsite;
  const thankyouPage = reclaimMode.enabled
    ? reclaimMode.globalReclaimConfig.thankyouPage
    : funnel.thankyouPage;

  const thankyouPageScript = reclaimMode.enabled
    ? reclaimMode.globalReclaimConfig.scriptThankyou
    : funnel.scriptThankyou;

  useEffect(() => {
    appendScriptHtml(thankyouPageScript, document.head);
    clearOtpSession();
  }, [thankyouPageScript]);

  return (
    <Wrapper className="text-center">
      <CheckedLogo src={checkedImage} alt="successfull" />
      <div className="mt-4 mb-2">
        <strong>{digitalThankyouConfig?.thankyouPageHeadline}</strong>
      </div>
      <Body>{digitalThankyouConfig?.thankyouPageText}</Body>
      <HausflixNotice />
      <Greeting>
        <strong>{digitalThankyouConfig?.greetingPhrase}</strong>
      </Greeting>
      {thankyouPage?.websiteButton === "Yes" && (
        <a href={websiteUrl}>
          <ThanksButton
            className="text-white mt-3"
            $backgroundColor={baseColor}
          >
            {thankyouPage.websiteButtonText}
          </ThanksButton>
        </a>
      )}
    </Wrapper>
  );
};

export default ThanksDigitalPage;
